import {  useState } from 'react'
import { useRemoteClientGet } from '../../../../../../configs/http-client'
import { CatchMessageError } from '../../../../../../remote/catch-message-error'
import { useLocalStorage } from '@/remote/local-storage'
import { useSearchParams } from 'react-router-dom'


export const LoadServiceId = () => {
  const [loading, setLoading] = useState(false)
    const { getUnitId } = useLocalStorage()
    const [params] = useSearchParams()

  const { remoteClientGet } = useRemoteClientGet()

  const load = async (id: string) => {
    if (!loading) {
      setLoading(true)
      try {
        const response = await remoteClientGet(`/servicos/${id}?idUnidade=${getUnitId() || params.get('unit')}`)
        return response.data.data
      } catch (error) {
        CatchMessageError(error)
      } finally {
        setLoading(false)
      }
    }
  }

  return {
    load,
  }
}